import React, { useEffect, useContext, useState } from "react";
import Footer from "../components/footer";
import EmployeeAttendanceWeekTable from "../components/employee_attendance_week_table";
import Toggle from "../components/toggle";
import { listOrganizationalUnits, getOrganizationalUnit } from "../services/api_org_unit";
import { AuthContext } from "../contexts/auth";
import EmployeeAttendanceMonthTable from "../components/employee_attendance_month_table";
import ComboboxAutocomplete from "../components/combobox_autocomplete";
import { getEmployeesWithActiveContract } from "../services/api_calendar";
import EmployeeAttendanceTable from "../components/employee_attendance_table";
import Fetching from "../components/fetching";
import CheckPermissions from "../components/check_permissions";
import ListBoxPageSize from "../components/listbox_pase_size";
import { Link } from "wouter";
import PopoverComponentCustom from "../components/popover_component";

  
function ShiftCalendar() {
    const { token, profile } = useContext(AuthContext);
    const [selectedOption, setSelectedOption] = useState(() => {
        if (profile.customer_type !== 'employee') {
            return 'GIORNALIERO';
        }

        return profile?.employee?.permissions?.includes('hr.view_shifts_all') || 
               profile?.employee?.permissions?.includes('hr.view_shifts_ou') ||
               profile?.employee?.permissions?.includes('hr.manage_shifts_all') || 
               profile?.employee?.permissions?.includes('hr.manage_shifts_ou')

            ? 'GIORNALIERO'
            : 'SETTIMANALE';
    });
    const [selectedUnitId, setSelectedUnitId] = useState(null);
    const [units, setUnits] = useState([]);
    const [unitData, setUnitData] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [isError, setIsError] = useState(false);
    const [totalResult, setTotalResult] = useState(0);
    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(25);
    const [nextPage, setNextPage] = useState(null);
    const [prevPage, setPrevPage] = useState(null);

    const isProfileComplete = profile.has_complete_profile;

    const selectedUnit = units.find(u => u.id === selectedUnitId)

    const handleToggleChange = (selectedOption) => {
        setSelectedOption(selectedOption);
    };

    // useEffect(() => {
    //     const controller = new AbortController();
    //     const signal = controller.signal;

    //     async function getData() {
    //         try {
    //             const response = await getEmployeesWithActiveContract(token, null, 'true', signal, page, pageSize);
    //             const employeesArray = Array.isArray(response.results) ? response.results : [];
    
    //             const sortedResponse = employeesArray.sort((a, b) => a.cf.localeCompare(b.cf));
    
    //             setTotalResult(response.count);
    
    //             setGlobalEmployees(sortedResponse);
    //             setFilteredEmployees(sortedResponse);             
    
    //         } catch (error) {
    //             if (error.name !== 'AbortError') {
    //                 console.log(error);
    //             }
    //         }
    //     }
    
    //     if (token) {
    //         getData();
    //     }
    
    //     return () => {
    //         controller.abort();
    //     };
    // }, [token, page, pageSize]);


    const handlePageSizeChange = (newPageSize) => {
        setPageSize(newPageSize); 
        setPage(1); 
    };

    const handleNextPage = () => {
        if (nextPage) {
          setPage(prevPage => prevPage + 1);
        }
    };
    
    const handlePreviousPage = () => {
    if (prevPage) {
        setPage(prevPage => prevPage - 1);
    }
    };

  useEffect(() => {
    const fetchUnits = async () => {
      setIsLoading(true);
      setIsError(false);

      try {
        const response = await listOrganizationalUnits(token, true, null, 'attendance');      
            setUnits(response.data || []);
        } catch (error) {  
            console.error('Error fetching units:', error);
            if (error.response && error.response.status !== 402) {
                setIsError(true);
            }
        } finally {
            setIsLoading(false);
        }
        };

        fetchUnits();
    }, [token]);

    const handleParentChange = (selectedParent) => {
        if (selectedParent) {
            const newParentId = selectedParent.id;
            setSelectedUnitId(newParentId);
        } else {
            setSelectedUnitId(null);
            setUnitData(null);
        }
    };

    const handleResetUnitSelection = () => {
        setSelectedUnitId(null);
    };

    if (isLoading) return <Fetching />
    if (isError) return <div>Error loading data</div>;

    return (
        <div className="flex flex-col min-h-screen">
            <PopoverComponentCustom title='Calendario Presenze' />
            {profile?.customer_type === 'company' && !isProfileComplete && profile?.company?.email == profile?.the_real_user_email && (
                <div className="w-full">
                    <div className="bg-orange-100 text-orange-600 p-4 mb-6">
                        <p className="text-center text-sm font-semibold">
                            Il profilo non è completo. <br />
                            Compila i campi mancanti{' '}
                            <Link
                            to="/profilo/fatturazione"
                            className="text-indigo-600 hover:text-indigo-800 underline"
                            >
                            cliccando qui
                            </Link>
                        </p>
                    </div>
                </div>
            )}
            <main className="flex-grow mt-10 pb-8">
                <div className='grid md:grid-cols-5 grid-cols-1 md:mx-4 mx-6 pb-5 z-30'>
                    <div className='col-hidden lg:block lg:col-span-1'></div>
                    <div className='col-span-1 flex items-center justify-start lg:justify-end lg:me-5'>
                        <h1 className="block font-medium text-gray-700 mb-4 md:mb-0 uppercase text-sm">Unità Organizzativa</h1>
                    </div>
                    <div className='col-span-1 flex items-center w-64'>
                        <ComboboxAutocomplete
                            options={units}
                            bgActiveColor="bg-indigo-100"
                            textActiveColor="text-gray-700"
                            placeholder='Seleziona Unità Organizzativa...'
                            onChange={handleParentChange}
                            value={selectedUnit}
                            positionOptions='absolute'
                            zIndex="99999"
                        />
                    </div>
                    <div className="col-span-1 flex items-center ml-10">
                        <button
                            className={`w-28 mt-2 sm:mt-0 inline-flex justify-center align-middle items-center rounded bg-indigo-600 h-6 text-xs font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 ${!selectedUnit ? 'invisible' : ''}`}
                            onClick={handleResetUnitSelection}
                            disabled={!selectedUnit}
                        >
                            Reset selezione
                        </button>
                    </div>
                </div>

                <div className="grid grid-cols items-center justify-center">
                    <Toggle
                        color="indigo"
                        gradeBgColor="600"
                        optionLeft="GIORNALIERO"
                        optionMiddle="SETTIMANALE"
                        optionRight="MENSILE"
                        selectedOption={selectedOption}
                        onChange={handleToggleChange}
                    />
                </div>
                
                <div className='px-8 py-3 w-full bg-white' style={{ position: 'relative', zIndex: '100' }}>
                    <ListBoxPageSize value={pageSize} onChange={handlePageSizeChange} />
                </div>
                

                <div className="flex flex-col items-center justify-center mx-4 pb-5">
                    {selectedOption === "GIORNALIERO" && (
                        <CheckPermissions permissionsToCheck={['hr.view_shifts_all', 'hr.view_shifts_ou', 'hr.manage_shifts_ou', 'hr.manage_shifts_all', 'hr.view_inouts_ou', 'hr.view_inouts_all', 'hr.manage_inouts_ou', 'hr.manage_inouts_all' ]}>
                            <EmployeeAttendanceTable
                                selectedUnit={selectedUnit}
                                page={page} 
                                setTotalResult={setTotalResult} 
                                pageSize={pageSize}
                                setNextPage={setNextPage}
                                setPrevPage={setPrevPage}
                            />
                        </CheckPermissions>
                    )}
                    {selectedOption === "SETTIMANALE" && (
                        <CheckPermissions permissionsToCheck={['hr.view_attendance_all', 'hr.view_attendance_ou']}>
                            <EmployeeAttendanceWeekTable 
                                selectedUnit={selectedUnit}
                                page={page} 
                                totalResult={totalResult}
                                setTotalResult={setTotalResult} 
                                pageSize={pageSize}
                                setNextPage={setNextPage}
                                setPrevPage={setPrevPage}
                            />
                        </CheckPermissions>
                    )}
                    {selectedOption === "MENSILE" && (
                        <CheckPermissions permissionsToCheck={['hr.view_attendance_all', 'hr.view_attendance_ou']}>
                            <EmployeeAttendanceMonthTable 
                                selectedUnit={selectedUnit}
                                page={page} 
                                totalResult={totalResult}
                                setTotalResult={setTotalResult} 
                                pageSize={pageSize}
                                setNextPage={setNextPage}
                                setPrevPage={setPrevPage} 
                            />
                        </CheckPermissions>
                    )}
                </div>
                {totalResult > pageSize && (
                    <div className="flex justify-between mt-8 px-8">
                        <button 
                            className="inline-flex items-center rounded-md bg-white px-2.5 py-1.5 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50"
                            onClick={handlePreviousPage}
                            disabled={!prevPage}
                        >
                            Precedente
                        </button>
                        <span className='text-sm font-medium text-gray-900'>Pagina {page} di {Math.ceil(totalResult / pageSize)}</span>
                        <button 
                            className="inline-flex items-center rounded-md bg-white px-2.5 py-1.5 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50"
                            onClick={handleNextPage} 
                            disabled={!nextPage}
                        >
                            Successivo
                        </button>
                    </div>
                )}
            </main>
            <Footer />
        </div>
    )
};

export default ShiftCalendar;
